import { ChangeDetectorRef, Component, Input, OnInit } from '@angular/core'
import { ActivatedRoute } from '@angular/router'
import { Observable, of, switchMap } from 'rxjs'
import { ICustomProduct } from '../../../models/interface/product.interface'
import { ProductDetailsService } from '../../../services/product.service'
import { UserPermissionService } from '../../../services/user-permission/user-permission.service'
import { CustomProductReplacementService } from './custom-product-replacement.service'

@Component({
    selector: 'app-custom-product-replacement',
    templateUrl: './custom-product-replacement.component.html',
    styleUrl: './custom-product-replacement.component.scss',
    standalone: false
})
export class CustomProductReplacementComponent implements OnInit {
  @Input() currentProduct: ICustomProduct
  @Input() compare: boolean = false
  public panelOpenState: boolean = true
  public replacementProduct$: Observable<ICustomProduct>
  public isProductDiscontinuedInRegion: boolean = false

  constructor(
    private productDetailsService: ProductDetailsService,
    public userPermissionService: UserPermissionService,
    private cdr: ChangeDetectorRef,
    private route: ActivatedRoute,
    private customProductReplacementService: CustomProductReplacementService
  ) {}

  ngOnInit(): void {
    const replacementProduct = this.currentProduct?.replacementProduct
    if (!replacementProduct) {
      this.route.params.subscribe((params) => {
        //access from pdp directly
        if (params.productCode) {
          this.getReplacementProductFromCurrentProductCode(params.productCode)
        }
      })
    } else {
      //access from product-list
      this.isProductDiscontinuedInRegion = this.customProductReplacementService.isDiscontinuedRegion(
        this.currentProduct
      )
      if (replacementProduct && this.isProductDiscontinuedInRegion) {
        this.replacementProduct$ = this.productDetailsService.getProductDetailByProductCode(replacementProduct)
      }
    }
  }

  private getReplacementProductFromCurrentProductCode(productCode: string): void {
    this.replacementProduct$ = this.productDetailsService.getProductDetailByProductCode(productCode).pipe(
      switchMap((currentProduct: ICustomProduct) => {
        this.isProductDiscontinuedInRegion = this.customProductReplacementService.isDiscontinuedRegion(currentProduct)

        if (this.isProductDiscontinuedInRegion && currentProduct.replacementProduct) {
          return this.productDetailsService.getProductDetailByProductCode(currentProduct.replacementProduct)
        } else {
          return of(null)
        }
      })
    )
    this.cdr.detectChanges()
  }
}
